import React, { useState, useEffect, useRef } from "react";
import {
  Upload,
  FileText,
  Download,
  Trash2,
  Eye,
  Calendar,
  User,
  Search,
  AlertCircle,
  CheckCircle,
  LogOut,
} from "lucide-react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import axios from "axios";

const Echanges = () => {
  console.log("🚀 Composant Echanges en cours de rendu...");
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("tous");
  const [fichiers, setFichiers] = useState([]);
  const [stats, setStats] = useState({ nouveau: 0, lu: 0, traite: 0 });
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formCategorie, setFormCategorie] = useState("comptable");
  const [formDescription, setFormDescription] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");
  const [comptables, setComptables] = useState([]);
  const [clientInfo, setClientInfo] = useState(null);
  const [echangesFiltres, setEchangesFiltres] = useState([]);

  const [notification, setNotification] = useState(null);
  const fileInputRef = useRef(null);

  const API_BASE_URL = "https://api-ec.cinef-expertises.com/api";

  // Fonction pour générer les initiales du client
  const getClientInitials = (clientInfo) => {
    if (!clientInfo) return "CE"; // CINEF Expertises par défaut
    
    // Si on a un nom complet (format "Prénom Nom")
    if (clientInfo.nom_complet) {
      const parts = clientInfo.nom_complet.trim().split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      } else if (parts.length === 1) {
        return parts[0].substring(0, 2).toUpperCase();
      }
    }
    
    // Si on a prénom et nom séparés
    if (clientInfo.prenom && clientInfo.nom) {
      return (clientInfo.prenom[0] + clientInfo.nom[0]).toUpperCase();
    }
    
    // Si on a seulement un nom d'entreprise
    if (clientInfo.nom_entreprise) {
      const parts = clientInfo.nom_entreprise.trim().split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      } else {
        return parts[0].substring(0, 2).toUpperCase();
      }
    }
    
    // Si on a seulement l'email
    if (clientInfo.email) {
      const emailPart = clientInfo.email.split('@')[0];
      return emailPart.substring(0, 2).toUpperCase();
    }
    
    return "CL"; // Client par défaut
  };

  // Fonction de déconnexion
  const handleLogout = () => {
    localStorage.removeItem('client_token');
    localStorage.removeItem('client_info');
    window.location.href = '/connexion';
  };

  const categories = [
    { value: "tous", label: "Tous les fichiers" },
    { value: "fiscal", label: "Documents fiscaux" },
    { value: "comptable", label: "Documents comptables" },
    { value: "juridique", label: "Documents juridiques" },
    { value: "bancaire", label: "Documents bancaires" },
  ];
  const token = localStorage.getItem("client_token");

  // Fonction pour récupérer les infos du client depuis localStorage
  const getClientInfo = () => {
    try {
      const clientInfoString = localStorage.getItem("client_info");
      if (clientInfoString) {
        const parsedClientInfo = JSON.parse(clientInfoString);
        console.log("📋 Informations du client récupérées:", parsedClientInfo);
        return parsedClientInfo;
      }
      console.warn("⚠️ Aucune information client trouvée dans localStorage");
      return null;
    } catch (error) {
      console.error("❌ Erreur lors du parsing des informations client:", error);
      return null;
    }
  };

  // Fonction pour filtrer les échanges selon le client connecté
  const filtrerEchangesParClient = (echanges, clientId) => {
    if (!clientId || !Array.isArray(echanges)) {
      console.warn("⚠️ Impossible de filtrer: clientId ou echanges manquant");
      console.warn("⚠️ clientId:", clientId);
      console.warn("⚠️ echanges isArray:", Array.isArray(echanges));
      return [];
    }
    
    console.log("🔍 DEBUT FILTRAGE - ID client connecté:", clientId, "type:", typeof clientId);
    console.log("🔍 Tous les échanges à filtrer:", echanges);
    
    const echangesFiltres = echanges.filter(echange => {
      const destinataireId = echange.destinataire_id;
      const isMatch = destinataireId === clientId || destinataireId == clientId;
      
      console.log(`🔍 Échange ID ${echange.id}:`);
      console.log(`   - destinataire_id: ${destinataireId} (type: ${typeof destinataireId})`);
      console.log(`   - client connecté: ${clientId} (type: ${typeof clientId})`);
      console.log(`   - correspondance ===: ${destinataireId === clientId}`);
      console.log(`   - correspondance ==: ${destinataireId == clientId}`);
      console.log(`   - retenu: ${isMatch}`);
      
      return isMatch;
    });
    
    console.log(`📊 RESULTAT FILTRAGE: ${echanges.length} total → ${echangesFiltres.length} pour le client ${clientId}`);
    console.log("📊 Échanges filtrés:", echangesFiltres);
    return echangesFiltres;
  };

  // Vérifier l'authentification au montage
  useEffect(() => {
    const token = localStorage.getItem("client_token");
    const clientData = getClientInfo();
    
    console.log("Vérification du token au montage:", token);
    console.log("Toutes les clés dans localStorage:", Object.keys(localStorage));
    console.log("🔍 INFORMATIONS CLIENT DETAILLEES:", clientData);
    
    if (clientData) {
      console.log("🔍 ID du client:", clientData.id, "type:", typeof clientData.id);
      console.log("🔍 Nom du client:", clientData.nom || clientData.name);
      console.log("🔍 Email du client:", clientData.email);
    }

    // Stocker les informations du client
    setClientInfo(clientData);

    // Debug détaillé du token
    if (token) {
      console.log("📋 Détails du token:");
      console.log("- Longueur:", token.length);
      console.log("- Premiers 50 caractères:", token.substring(0, 50));
      console.log("- Contient 'Bearer':", token.includes('Bearer'));
      console.log("- Format suspect:", token.split('|').length > 1);
    }
    
    // Temporairement, on ne redirige pas automatiquement pour debug
    if (!token) {
      console.warn("Aucun token trouvé, mais on continue pour debug"); 
      // window.location.href = "/login";
      // return;
    }
  }, []);

  // Test direct du token
  // const testTokenDirect = async (token) => {
  //   console.log("🧪 Test direct du token...");
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/echanges/comptables`, {
  //       method: 'GET',
  //       headers: {
  //         "Authorization": `Bearer ${token}`,
  //         "Accept": "application/json",
  //         "Content-Type": "application/json"
  //       }
  //     });
      
  //     console.log("🧪 Test token - Status:", response.status);
  //     console.log("🧪 Test token - Headers de réponse:", Object.fromEntries(response.headers));
  //     console.log("🧪 Test data", response);
  //     if (!response.ok) {
  //       const errorText = await response.text();
  //       console.log("🧪 Test token - Erreur:", errorText);
  //     } else {
  //       const data = await response.json();
  //       console.log("🧪 Test token - Succès:", data);
  //     }
  //   } catch (error) {
  //     console.error("🧪 Test token - Exception:", error);
  //   }
  // };

  // Charger les fichiers et stats au montage
  useEffect(() => {
    if (token && clientInfo) {
      loadFichiers();
      loadStats();
      loadComptables();
      fetchEchanges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, searchTerm, clientInfo]);

  const fetchEchanges = async () => {
    console.log("🔄 fetchEchanges - Début");
    try {
      const headers = getAuthHeaders();
      if (Object.keys(headers).length === 0) {
        console.warn("⚠️ Pas de headers d'authentification");
        return;
      }
      
      if (!clientInfo || !clientInfo.id) {
        console.warn("⚠️ Informations client manquantes pour le filtrage");
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/echanges/comptables`, {
        method: 'GET',
        headers
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log("📁 Données échanges brutes:", data);
      
      const echangesListe = data?.data ?? data;
      const echangesArray = Array.isArray(echangesListe) ? echangesListe : [];
      
      // Filtrer les échanges pour le client connecté
      const echangesFiltresClient = filtrerEchangesParClient(echangesArray, clientInfo.id);
      setEchangesFiltres(echangesFiltresClient);
      
      console.log("✅ Échanges filtrés et stockés:", echangesFiltresClient.length, "éléments");
      
    } catch (err) {
      if (!handleAuthError(err)) {
        console.error("❌ Erreur API fetchEchanges:", err.response ? err.response.data : err.message);
        showNotification("Erreur lors de la récupération des échanges", "error");
      }
      setEchangesFiltres([]);
    }
  };

  const loadComptables = async () => {
    console.log("📁 loadComptables - Début");
    try {
      const token = localStorage.getItem("client_token");
      
      if (!token) {
        console.warn("⚠️ Aucun token trouvé pour loadComptables");
        showNotification("Token manquant. Veuillez vous reconnecter.", "error");
        return;
      }
      
      console.log(" loadComptables - Appel API /echanges/comptables avec token:", token.substring(0, 20) + "...");
      
      const response = await fetch(`${API_BASE_URL}/echanges/comptables`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      });

      console.log("📁 data:", response);
      
      console.log("📁 loadComptables - Réponse reçue, status:", response.status);
      
      if (!response.ok) {
        const errorData = await response.text();
        console.error("❌ loadComptables - Erreur HTTP:", response.status, errorData);
        throw new Error(`Erreur HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log("📁 loadComptables - Données reçues:", data);
      
      const comptablesList = data?.data ?? data;
      setComptables(Array.isArray(comptablesList) ? comptablesList : []);
      
    } catch (error) {
      console.error("❌ loadComptables - Erreur:", error);
      if (error.message.includes('401') || error.message.includes('Unauthorized')) {
        showNotification("Session expirée. Veuillez vous reconnecter.", "error");
      } else {
        showNotification("Erreur lors du chargement des comptables", "error");
      }
      setComptables([]);
    }
  };

  // Fonction pour afficher les notifications
  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  // Fonction utilitaire pour les headers authentifiés
  const getAuthHeaders = () => {
    const token = localStorage.getItem("client_token");
    
    console.log("🔑 getAuthHeaders - Token trouvé:", !!token);
    if (token) {
      console.log("🔑 Token (premiers 30 caractères):", token.substring(0, 30) + "...");
      console.log("🔑 Longueur du token:", token.length);
    } else {
      console.warn("⚠️ Aucun token trouvé dans localStorage");
    }
    
    if (!token) {
      console.warn("⚠️ Aucun token d'authentification trouvé");
      showNotification("Aucun token d'authentification. Veuillez vous connecter.", "error");
      // On retourne des headers vides mais on ne redirige pas automatiquement
      return {};
    }
    
    return {
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    };
  };
  
  // Fonction pour gérer les erreurs d'authentification
  const handleAuthError = (error) => {
    console.log("🔍 handleAuthError appelée avec:", error);
    if (error.response) {
      console.log("🔍 Status de l'erreur:", error.response.status);
      console.log("🔍 Données de l'erreur:", error.response.data);
    }
    
    if (error.response && error.response.status === 401) {
      console.error("❌ Token expiré ou invalide (401)");
      showNotification("Erreur d'authentification. Vérifiez votre token.", "error");
      // Ne pas supprimer le token ni rediriger automatiquement pour debug
      // localStorage.removeItem("client_token");
      // window.location.href = "/login";
      return true;
    }
    return false;
  };

  // Charger la liste des fichiers (maintenant utilise les échanges filtrés)
  const loadFichiers = async () => {
    console.log("📁 loadFichiers - Début");
    try {
      const token = localStorage.getItem("client_token");
      
      if (!token) {
        console.warn("⚠️ Aucun token trouvé pour loadFichiers");
        showNotification("Token manquant. Veuillez vous reconnecter.", "error");
        return;
      }
      
      if (!clientInfo || !clientInfo.id) {
        console.warn("⚠️ Informations client manquantes pour loadFichiers");
        return;
      }
      
      console.log("📁 loadFichiers - Appel API /echanges avec token:", token.substring(0, 20) + "...");
      
      const response = await fetch(`${API_BASE_URL}/echanges`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      });
      
      console.log("📁 loadFichiers - Réponse reçue, status:", response.status);
      
      if (!response.ok) {
        const errorData = await response.text();
        console.error("❌ loadFichiers - Erreur HTTP:", response.status, errorData);
        throw new Error(`Erreur HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log("📁 loadFichiers - Données reçues:", data);
      console.log("📁 Structure complète des données:", JSON.stringify(data, null, 2));
      
      const fichiersListe = data?.data ?? data;
      const fichiersArray = Array.isArray(fichiersListe) ? fichiersListe : [];
      
      console.log("📁 Fichiers avant filtrage:", fichiersArray.length);
      fichiersArray.forEach((fichier, index) => {
        console.log(`📁 Fichier ${index + 1}:`, {
          id: fichier.id,
          destinataire_id: fichier.destinataire_id,
          nom: fichier.nom || fichier.nom_fichier,
          statut: fichier.statut
        });
      });
      
      // Filtrer les fichiers pour le client connecté
      const fichiersFiltres = filtrerEchangesParClient(fichiersArray, clientInfo.id);
      setFichiers(fichiersFiltres);
      
      console.log("📁 Premier fichier (structure):", fichiersFiltres[0]);
      
    } catch (error) {
      console.error("❌ loadFichiers - Erreur:", error);
      if (error.message.includes('401') || error.message.includes('Unauthorized')) {
        showNotification("Session expirée. Veuillez vous reconnecter.", "error");
      } else {
        showNotification("Erreur lors du chargement des fichiers", "error");
      }
      setFichiers([]);
    }
  };


  // Charger les statistiques (maintenant filtrées par client)
  const loadStats = async () => {
    console.log("📊 loadStats - Début");
    try {
      const token = localStorage.getItem("client_token");
      
      if (!token) {
        console.warn("⚠️ Aucun token trouvé pour loadStats");
        return;
      }
      
      if (!clientInfo || !clientInfo.id) {
        console.warn("⚠️ Informations client manquantes pour loadStats");
        // Mettre des stats à zéro en attendant les infos client
        setStats({ nouveau: 0, lu: 0, traite: 0 });
        return;
      }
      
      console.log("📊 loadStats - Appel API /echanges avec token:", token.substring(0, 20) + "...");
      
      // Récupérer tous les échanges au lieu des stats globales
      const response = await fetch(`${API_BASE_URL}/echanges`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      });
      
      console.log("📊 loadStats - Réponse reçue, status:", response.status);
      
      if (!response.ok) {
        const errorData = await response.text();
        console.error("❌ loadStats - Erreur HTTP:", response.status, errorData);
        setStats({ nouveau: 0, lu: 0, traite: 0 });
        return;
      }
      
      const data = await response.json();
      console.log("📊 loadStats - Données reçues:", data);
      
      const echangesListe = data?.data ?? data;
      const echangesArray = Array.isArray(echangesListe) ? echangesListe : [];
      
      // Filtrer les échanges pour le client connecté
      const echangesFiltresClient = filtrerEchangesParClient(echangesArray, clientInfo.id);
      
      // Calculer les stats à partir des échanges filtrés
      const statsCalculees = echangesFiltresClient.reduce((acc, echange) => {
        const statut = echange.statut || echange.status || 'nouveau';
        switch(statut.toLowerCase()) {
          case 'nouveau':
          case 'new':
            acc.nouveau++;
            break;
          case 'lu':
          case 'read':
            acc.lu++;
            break;
          case 'traite':
          case 'traité':
          case 'treated':
          case 'processed':
            acc.traite++;
            break;
          default:
            acc.nouveau++;
            break;
        }
        return acc;
      }, { nouveau: 0, lu: 0, traite: 0 });
      
      console.log("📊 Stats calculées pour le client:", statsCalculees);
      setStats(statsCalculees);
      
    } catch (error) {
      console.error("❌ loadStats - Erreur:", error);
      setStats({ nouveau: 0, lu: 0, traite: 0 });
    }
  };


  // Gérer le clic sur le bouton d'upload
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  // Gérer la sélection de fichiers
  // Gérer la sélection de fichiers
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "image/jpeg",
      "image/png",
    ];

    if (!allowedTypes.includes(file.type)) {
      showNotification("Type de fichier non autorisé.", "error");
      event.target.value = "";
      return;
    }

    setSelectedFile(file);
    setShowForm(true);
  };


  // Aperçu d'un fichier
  const handleApercu = async (fichier) => {
    try {
      const response = await fetch(`https://api-ec.cinef-expertises.com/api/echanges/${fichier.id}/apercu`, {
        headers: getAuthHeaders()
      });

      const data = await response.json();

      if (data.success) {
        window.open(data.data.url, "_blank");
        loadFichiers();
        loadStats();
      } else {
        showNotification(data.message || "Erreur lors de l'aperçu", "error");
      }
    } catch (error) {
      console.error("Erreur aperçu:", error);
      showNotification("Erreur lors de l'aperçu", "error");
    }
  };

  // Télécharger un fichier
  const handleDownload = async (fichier) => {
    try {
      const response = await fetch(`https://api-ec.cinef-expertises.com/api/echanges/${fichier.id}/download`, {
        headers: getAuthHeaders()
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fichier.nom;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        showNotification("Téléchargement réussi!", "success");
      } else {
        const data = await response.json();
        showNotification(data.message || "Erreur lors du téléchargement", "error");
      }
    } catch (error) {
      console.error("Erreur téléchargement:", error);
      showNotification("Erreur lors du téléchargement", "error");
    }
  };

  // Supprimer - CORRIGÉ
  // const handleDelete = async (fichier) => {
  //   if (!window.confirm(`Voulez-vous vraiment supprimer "${fichier.nom}" ?`)) {
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`https://api-ec.cinef-expertises.com/api/echanges/${fichier.id}`, {
  //       method: "DELETE",
  //       headers: getAuthHeaders()
  //     });



  //     const data = await response.json();

  //     if (data.success) {
  //       showNotification("Fichier supprimé avec succès!", "success");
  //       loadFichiers();
  //       loadStats();
  //     } else {
  //       showNotification(data.message || "Erreur lors de la suppression", "error");
  //     }
  //   } catch (error) {
  //     console.error("Erreur suppression:", error);
  //     showNotification("Erreur lors de la suppression", "error");
  //   }
  // };
// 
  const getFileIcon = (type) => {
    switch (type) {
      case "pdf":
        return "📄";
      case "excel":
        return "📊";
      case "word":
        return "📝";
      case "image":
        return "🖼️";
      default:
        return "📄";
    }
  };

  const getStatutStyle = (statut) => {
    return statut;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const handleUploadConfirm = async () => {
    console.log("📤 Upload - Début");
    console.log("📤 selectedFile:", selectedFile);
    console.log("📤 selectedClientId:", selectedClientId);
    console.log("📤 formCategorie:", formCategorie);
    console.log("📤 formDescription:", formDescription);
    
    if (!selectedFile || !selectedClientId) {
      console.warn("📤 Upload - Données manquantes");
      showNotification("Veuillez sélectionner un fichier et un destinataire", "error");
      return;
    }

    const formData = new FormData();
    formData.append("destinataire_id", selectedClientId);
    formData.append("fichier", selectedFile);
    formData.append("categorie", formCategorie);
    formData.append("description", formDescription);
    
    console.log("📤 FormData contents:");
    for (let [key, value] of formData.entries()) {
      console.log(`📤 ${key}:`, value);
    }

    try {
      setUploadProgress(true);

      const response = await fetch(`${API_BASE_URL}/echanges`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
          // NE PAS mettre Content-Type avec FormData !
        },
        body: formData
      });

      console.log("📤 Upload - Status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("📤 Upload - Erreur HTTP:", response.status, errorText);
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log("📤 Upload - Succès:", data);

      if (data.success) {
        showNotification("✅ Fichier envoyé !");
        setShowForm(false);
        setSelectedFile(null);
        setFormDescription("");
        setFormCategorie("comptable");
        setSelectedClientId("");

        loadFichiers();
        loadStats();
      } else {
        showNotification(data.message || "Erreur lors de l'upload", "error");
      }
    } catch (error) {
      console.error("❌ Upload - Erreur:", error);
      showNotification("Erreur serveur", "error");
    } finally {
      setUploadProgress(false);
    }
  };



  return (
    <>
      {/* Mobile Navigation Header */}
      <div className="mobile-nav-header">
        <div className="mobile-nav-brand">
          <div className="mobile-logo">
            <span className="logo-text">CINEF</span>
          </div>
          <div className="mobile-nav-title">
            {clientInfo ? (
              <span>{clientInfo.email || clientInfo.nom_entreprise || clientInfo.nom_complet}</span>
            ) : (
              'Échanges de Fichiers'
            )}
          </div>
        </div>
        <div className="mobile-nav-actions">
          <button onClick={handleLogout} className="mobile-logout-btn">
            <LogOut size={18} />
            <span className="logout-text">Déconnexion</span>
          </button>
        </div>
      </div>

      <div className="app-container">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="main-wrapper">
          <Navbar onMenuToggle={() => setIsSidebarOpen(!isSidebarOpen)} />

          <main className="main-content">
            {/* Debug info - sera visible dans la console */}
            {console.log("🔧 Debug - Token:", localStorage.getItem("client_token") ? "Présent" : "Absent")}
            {console.log("🔧 Debug - Fichiers:", fichiers.length, "Comptables:", comptables.length)}
            
            {/* Notification */}
            {/* Notification */}
            {notification && (
              <div className={`notification ${notification.type}`}>
                {notification.type === "success" ? (
                  <CheckCircle size={20} />
                ) : (
                  <AlertCircle size={20} />
                )}
                <span>{notification.message}</span>
              </div>
            )}

            {/* Header Section */}
            <div className="page-header">
              <div className="header-content">
                <div className="header-text">
                  <h1 className="page-title">Échanges de Fichiers</h1>
                  <p className="page-subtitle">
                    Partagez et gérez vos documents en toute sécurité
                  </p>
                </div>
              </div>
            </div>

            {/* Upload Section */}
            <div className="upload-section">
              <div className="upload-zone" onClick={handleUploadClick}>
                <Upload size={48} className="upload-icon" />
                <h3 className="upload-title">
                  {uploadProgress
                    ? "Upload en cours..."
                    : "Glissez vos fichiers ici"}
                </h3>
                <p className="upload-subtitle">ou cliquez pour parcourir</p>
                <button className="btn-upload" disabled={uploadProgress}>
                  {uploadProgress
                    ? "Chargement..."
                    : "Sélectionner des fichiers"}
                </button>
                <input
                  ref={fileInputRef}
                  type="file"
                  onChange={handleFileSelect}
                  accept=".pdf,.doc,.docx,.xlsx,.xls,.png,.jpg,.jpeg"
                  style={{ display: "none" }}
                />
              </div>
            </div>

            {showForm && (
              <div className="form-popup">
                <div className="form-content">

                  <label>Destinataire</label>
                  <select
                    className="form-control"
                    value={selectedClientId}
                    onChange={(e) => setSelectedClientId(e.target.value)}
                  >
                    <option value="">-- Sélectionnez le comptable --</option>
                    {comptables.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.nom} {c.prenom}
                      </option>
                    ))}
                  </select>

                  <h3>Informations sur le fichier</h3>

                  <p><strong>Fichier :</strong> {selectedFile.name}</p>

                  <label>Catégorie</label>
                  <select
                    className="form-control"
                    value={formCategorie}
                    onChange={(e) => setFormCategorie(e.target.value)}
                  >
                    <option value="comptable">Comptable</option>
                    <option value="fiscal">Fiscal</option>
                    <option value="juridique">Juridique</option>
                    <option value="bancaire">Bancaire</option>
                  </select>

                  <label>Description / Objet</label>
                  <textarea
                    className="form-control"
                    value={formDescription}
                    onChange={(e) => setFormDescription(e.target.value)}
                  />

                  <button className="btn primary" onClick={handleUploadConfirm}>
                    Envoyer le fichier
                  </button>

                  <button className="btn danger" onClick={() => setShowForm(false)}>
                    Annuler
                  </button>
                </div>
              </div>
            )}


            {/* Filters Section */}
            <div className="filters-section">
              <div className="search-box">
                <Search size={20} className="search-icon" />
                <input
                  type="text"
                  placeholder="Rechercher un fichier..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>

              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="category-select"
              >
                {categories.map((cat) => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Stats Cards */}
            <div className="stats-grid">
              <div className="stat-card nouveau">
                <div className="stat-content">
                  <div className="stat-info">
                    <h3 className="stat-title">Nouveaux</h3>
                    <p className="stat-value">{stats.nouveau}</p>
                  </div>
                  <div className="stat-icon">
                    <FileText size={40} />
                  </div>
                </div>
              </div>

              <div className="stat-card lu">
                <div className="stat-content">
                  <div className="stat-info">
                    <h3 className="stat-title">Lus</h3>
                    <p className="stat-value">{stats.lu}</p>
                  </div>
                  <div className="stat-icon">
                    <Eye size={40} />
                  </div>
                </div>
              </div>

              <div className="stat-card traite">
                <div className="stat-content">
                  <div className="stat-info">
                    <h3 className="stat-title">Traités</h3>
                    <p className="stat-value">{stats.traite}</p>
                  </div>
                  <div className="stat-icon">
                    <Download size={40} />
                  </div>
                </div>
              </div>
            </div>

            {/* Files List */}
            <div className="fichiers-container">
              <div className="container-header">
                <h2 className="container-title">
                  Fichiers partagés ({fichiers.length})
                </h2>
              </div>

              {loading ? (
                <div className="loading-state">
                  <div className="spinner"></div>
                  <p>Chargement des fichiers...</p>
                </div>
              ) : fichiers.length === 0 ? (
                <div className="empty-state">
                  <FileText size={64} className="empty-icon" />
                  <h3>Aucun fichier trouvé</h3>
                  <p>Commencez par uploader un document</p>
                </div>
              ) : (
                <div className="fichiers-list">
                  {fichiers.map((fichier) => (
                    <div key={fichier.id} className="fichier-item">
                      <div className="fichier-content">
                        <div className="fichier-main">
                          <div className="file-icon">
                            {getFileIcon(fichier.type)}
                          </div>
                          <div className="fichier-info">
                            <h4 className="fichier-title">{fichier.nom}</h4>
                            <p className="fichier-description">
                              {fichier.description}
                            </p>
                            <div className="fichier-meta">
                              <span className="fichier-date">
                                <Calendar size={14} />
                                {formatDate(  fichier.created_at)} |  {fichier.taille_fichier}
                              </span>
                              <span className="fichier-uploader">
                                <User size={14} />
                                {fichier.expediteur ? `${fichier.expediteur.nom} ${fichier.expediteur.prenom}` : 'Expéditeur inconnu'}
                              </span>
                              <span className="fichier-taille">
                                {fichier.taille}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="fichier-actions">
                          <div className="fichier-status-section">
                            <span
                              className={`status-badge ${getStatutStyle(
                                fichier.statut
                              )}`}
                            >
                              {fichier.statut.toUpperCase()}
                            </span>
                          </div>

                          <div className="action-buttons">
                            {/* <button
                              className="btn-action primary"
                              onClick={() => handleApercu(fichier)}
                            >
                              <Eye size={14} />
                              Aperçu
                            </button> */}
                            <button
                              className="btn-action secondary"
                              onClick={() => handleDownload(fichier)}
                            >
                              <Download size={14} />
                              Télécharger
                            </button>
                            {/* <button
                              className="btn-action danger"
                              onClick={() => handleDelete(fichier)}
                            >
                              <Trash2 size={14} />
                            ".concat(JSON.stringify(n.hmr.runtime)  Supprimer
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </main>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
import { FaBalanceScale } from 'react-icons/fa';

        .app-container {
          display: flex;
          height: 100vh;
          background: linear-gradient(135deg, #f8fafb 0%, #f1f5f9 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .main-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 280px;
        }

        .main-content {
          flex: 1;
          padding: 32px;
          overflow-y: auto;
          max-width: calc(100vw - 280px);
          box-sizing: border-box;
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 138, 68, 0.3) transparent;
        }

        .main-content::-webkit-scrollbar {
          width: 6px;
        }

        .main-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .main-content::-webkit-scrollbar-thumb {
          background: rgba(0, 138, 68, 0.2);
          border-radius: 10px;
        }

        /* Notification */
        .notification {
          position: fixed;
          top: 24px;
          right: 24px;
          z-index: 1000;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 24px;
          border-radius: 12px;
          background: white;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          font-weight: 600;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from { transform: translateX(400px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        .notification.success {
          border-left: 4px solid #10b981;
          color: #059669;
        }

        .notification.error {
          border-left: 4px solid #dc3545;
          color: #b91c1c;
        }

        /* Loading & Empty States */
        .loading-state,
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          text-align: center;
        }

        .spinner {
          width: 48px;
          height: 48px;
          border: 4px solid #f3f4f6;
          border-top-color: #10b981;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 16px;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .empty-icon {
          color: #d1d5db;
          margin-bottom: 16px;
        }

        .empty-state h3 {
          font-size: 18px;
          font-weight: 600;
          color: #374151;
          margin: 0 0 8px 0;
        }

        .empty-state p {
          color: #9ca3af;
          margin: 0;
        }

        /* Header Section */
        .page-header {
          margin-bottom: 32px;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .header-text {
          flex: 1;
        }

        .page-title {
          font-size: 32px;
          font-weight: 700;
          margin: 0 0 6px 0;
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }

        .page-subtitle {
          color: #64748b;
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }

        /* Upload Section */
        .upload-section {
          margin-bottom: 32px;
        }

        .upload-zone {
          background: #ffffff;
          border: 2px dashed #d1d5db;
          border-radius: 16px;
          padding: 40px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .upload-zone:hover {
          border-color: #10b981;
          background: linear-gradient(135deg, rgba(16, 185, 129, 0.02) 0%, rgba(220, 53, 69, 0.02) 100%);
        }

        .upload-icon {
          color: #9ca3af;
          margin-bottom: 16px;
        }

        .upload-title {
          font-size: 20px;
          font-weight: 600;
          color: #374151;
          margin: 0 0 8px 0;
        }

        .upload-subtitle {
          color: #6b7280;
          margin: 0 0 24px 0;
          font-size: 14px;
        }

        .btn-upload {
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
          border: none;
          padding: 12px 24px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .btn-upload:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
        }

        .btn-upload:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        /* Form Popup */
        .form-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}
.form-content {
  background: white;
  padding: 35px;
  border-radius: 16px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
.form-content h2 {
  margin: 0 0 25px 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
}
.form-content label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.form-content input,
.form-content select,
.form-content textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 15px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  font-family: inherit;
  box-sizing: border-box;
}
.form-content input:focus,
.form-content select:focus,
.form-content textarea:focus {
  outline: none;
  border-color: #008A44;
  box-shadow: 0 0 0 3px rgba(0,138,68,0.1);
}
.form-content textarea {
  resize: vertical;
  min-height: 80px;
}
.btn.primary {
  background: linear-gradient(135deg, #008A44 0%, #00a854 100%);
  color: white;
  padding: 14px 24px;
  border-radius: 10px;
  margin-top: 10px;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0,138,68,0.3);
}
.btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,138,68,0.4);
}
.btn.danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  padding: 14px 24px;
  border-radius: 10px;
  margin-top: 10px;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(220,53,69,0.3);
}
.btn.danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(220,53,69,0.4);
}

        /* Filters Section */
        .filters-section {
          display: flex;
          gap: 16px;
          margin-bottom: 32px;
          align-items: center;
        }

        .search-box {
          position: relative;
          flex: 1;
          max-width: 400px;
        }

        .search-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: #9ca3af;
        }

        .search-input {
          width: 100%;
          padding: 12px 16px 12px 48px;
          border: 1px solid #d1d5db;
          border-radius: 12px;
          background: #ffffff;
          font-size: 14px;
          font-family: inherit;
          transition: all 0.2s ease;
        }

        .search-input:focus {
          outline: none;
          border-color: #10b981;
          box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
        }

        .category-select {
          padding: 12px 16px;
          border: 1px solid #d1d5db;
          border-radius: 12px;
          background: #ffffff;
          font-size: 14px;
          font-family: inherit;
          cursor: pointer;
          min-width: 200px;
        }

        .category-select:focus {
          outline: none;
          border-color: #10b981;
        }

        /* Stats Grid */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 24px;
          margin-bottom: 32px;
        }

        .stat-card {
          background: #ffffff;
          padding: 28px;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .stat-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: currentColor;
        }

        .stat-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
        }

        .stat-card.nouveau {
          color: #dc3545;
        }

        .stat-card.lu {
          color: #f59e0b;
        }

        .stat-card.traite {
          color: #10b981;
        }

        .stat-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .stat-info {
          flex: 1;
        }

        .stat-title {
          font-size: 16px;
          font-weight: 600;
          color: currentColor;
          margin: 0 0 12px 0;
          opacity: 0.9;
        }

        .stat-value {
          font-size: 36px;
          font-weight: 700;
          color: currentColor;
          margin: 0;
          line-height: 1;
        }

        .stat-icon {
          opacity: 0.8;
          color: currentColor;
        }

        /* Files Container */
        .fichiers-container {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
          overflow: hidden;
          margin-bottom: 40px;
        }

        .container-header {
          padding: 24px 28px;
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.05) 0%, rgba(0, 138, 68, 0.05) 100%);
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .container-title {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
          letter-spacing: -0.3px;
        }

        .fichiers-list {
          padding: 0;
        }

        .fichier-item {
          padding: 24px 28px;
          border-bottom: 1px solid #f1f5f9;
          transition: all 0.2s ease;
        }

        .fichier-item:last-child {
          border-bottom: none;
        }

        .fichier-item:hover {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .fichier-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
        }

        .fichier-main {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          flex: 1;
          min-width: 0;
        }

        .file-icon {
          font-size: 32px;
          margin-top: 4px;
          flex-shrink: 0;
        }

        .fichier-info {
          flex: 1;
          min-width: 0;
        }

        .fichier-title {
          font-size: 17px;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 6px 0;
          line-height: 1.3;
        }

        .fichier-description {
          font-size: 14px;
          color: #64748b;
          margin: 0 0 12px 0;
          line-height: 1.4;
        }

        .fichier-meta {
          display: flex;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }

        .fichier-date,
        .fichier-uploader,
        .fichier-taille {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
        }

        .fichier-actions {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-shrink: 0;
        }

        .fichier-status-section {
          text-align: right;
        }

        .status-badge {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .status-badge.nouveau {
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: #ffffff;
        }

        .status-badge.lu {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          color: #ffffff;
        }

        .status-badge.traite {
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
        }

        .action-buttons {
          display: flex;
          gap: 8px;
        }

        .btn-action {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          border: none;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: inherit;
        }

        .btn-action.primary {
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
        }

        .btn-action.primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }

        .btn-action.secondary {
          background: linear-gradient(135deg, #6366f1, #4f46e5);
          color: #ffffff;
        }

        .btn-action.secondary:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
        }

        .btn-action.danger {
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: #ffffff;
        }

        .btn-action.danger:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
        }

        /* Mobile Navigation */
        .mobile-nav-header {
          display: none;
          justify-content: space-between;
          align-items: center;
          padding: 12px 16px;
          background: linear-gradient(135deg, #dc3545, #008A44);
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 9999;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
          backdrop-filter: blur(10px);
          height: 60px;
          box-sizing: border-box;
        }

        .mobile-nav-brand {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;
          min-width: 0;
        }

        .mobile-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 36px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          flex-shrink: 0;
        }

        .logo-text {
          font-size: 12px;
          font-weight: 700;
          color: white;
          letter-spacing: 0.5px;
        }

        .mobile-nav-title {
          font-size: 14px;
          font-weight: 600;
          color: white;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
          flex: 1;
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .mobile-nav-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-shrink: 0;
        }

        .mobile-logout-btn {
          display: flex !important;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 8px 12px;
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
          min-width: 44px;
          min-height: 36px;
          white-space: nowrap;
        }

        .mobile-logout-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }

        .mobile-logout-btn:active {
          transform: scale(0.95);
          background: rgba(255, 255, 255, 0.1);
        }

        .logout-text {
          font-size: 12px;
          font-weight: 600;
        }

        /* Responsive Design */
        @media (max-width: 1023px) {
          /* Masquer la navbar normale sur mobile et tablette */
          .main-wrapper > nav,
          .main-wrapper > header,
          .main-navbar,
          .navbar-container {
            display: none !important;
          }

          .mobile-nav-header {
            display: flex !important;
          }

          .main-wrapper {
            margin-left: 0 !important;
            width: 100% !important;
          }

          .main-content {
            margin-top: 70px !important;
            padding-top: 20px !important;
            padding: 24px;
          }

          .page-title {
            font-size: 28px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }

          .stat-card {
            padding: 20px;
          }

          .filters-section {
            padding: 16px;
          }

          .filter-buttons {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }

          .filter-btn {
            padding: 12px 16px;
            font-size: 14px;
          }

          .fichier-item {
            padding: 20px;
          }

          .btn-action {
            padding: 12px 20px;
            font-size: 14px;
          }
        }

        @media (max-width: 768px) {
          .mobile-nav-header {
            padding: 10px 16px !important;
            height: 56px !important;
          }

          .mobile-logo {
            width: 40px !important;
            height: 32px !important;
          }

          .logo-text {
            font-size: 10px !important;
          }

          .mobile-nav-title {
            font-size: 13px !important;
          }

          .logout-text {
            display: inline !important;
            font-size: 11px !important;
          }

          .mobile-logout-btn {
            padding: 6px 10px !important;
            min-width: 40px !important;
            min-height: 32px !important;
          }

          .main-content {
            padding: 16px !important;
            margin-top: 66px !important;
          }

          .header-content {
            flex-direction: column;
            align-items: center;
            gap: 16px;
            text-align: center;
            padding: 20px 16px;
            background: white;
            border-radius: 12px;
            margin-bottom: 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .page-title {
            font-size: 24px;
            text-align: center;
            width: 100%;
          }

          .page-subtitle {
            text-align: center;
            width: 100%;
            font-size: 14px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }

          .stat-card {
            padding: 16px;
          }

          .stat-title {
            font-size: 14px;
          }

          .stat-value {
            font-size: 28px;
          }

          .upload-section {
            margin: 16px 0;
          }

          .upload-zone {
            padding: 24px 16px;
            text-align: center;
          }

          .upload-content h3 {
            font-size: 18px;
          }

          .upload-content p {
            font-size: 13px;
          }

          .filters-section {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 16px;
          }

          .search-box {
            max-width: none;
            width: 100%;
          }

          .search-input {
            padding: 14px 16px 14px 44px;
            font-size: 16px;
          }

          .filter-buttons {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .filter-btn {
            padding: 12px 16px;
            font-size: 13px;
            text-align: center;
          }

          .fichiers-container {
            margin: 16px 0;
          }

          .container-header {
            padding: 16px 20px;
          }

          .container-title {
            font-size: 18px;
          }

          .fichier-item {
            padding: 20px;
          }

          .fichier-content {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
          }

          .fichier-main {
            gap: 12px;
          }

          .fichier-title {
            font-size: 16px;
          }

          .fichier-description {
            font-size: 13px;
          }

          .fichier-meta {
            flex-wrap: wrap;
            gap: 8px;
          }

          .meta-item {
            font-size: 12px;
          }

          .fichier-actions {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
            justify-content: center;
          }

          .action-buttons {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            width: 100%;
          }

          .btn-action {
            flex: 1;
            min-width: 120px;
            justify-content: center;
            font-size: 13px;
            padding: 12px 16px;
          }

          .status-badge {
            font-size: 11px;
            padding: 6px 12px;
          }
        }

        @media (max-width: 480px) {
          .mobile-nav-header {
            display: flex !important;
            padding: 8px 12px !important;
            height: 52px !important;
          }

          .mobile-nav-brand {
            gap: 8px !important;
          }

          .mobile-logo {
            width: 36px !important;
            height: 28px !important;
          }

          .logo-text {
            font-size: 9px !important;
          }

          .mobile-nav-title {
            font-size: 12px !important;
          }

          .logout-text {
            display: none !important;
          }

          .mobile-logout-btn {
            padding: 8px !important;
            min-width: 36px !important;
            border-radius: 18px !important;
            min-height: 36px !important;
          }

          .main-wrapper {
            margin-left: 0 !important;
            width: 100% !important;
          }

          .main-content {
            padding: 8px !important;
            margin-top: 60px !important;
            min-height: calc(100vh - 80px) !important;
            max-width: 100% !important;
          }

          .header-content {
            padding: 16px 12px !important;
            text-align: center;
            background: white;
            border-radius: 12px;
            margin: 0 0 16px 0 !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .page-title {
            font-size: 20px !important;
            margin-bottom: 6px !important;
            color: #1e293b;
            font-weight: 700;
          }

          .page-subtitle {
            font-size: 13px !important;
            color: #64748b;
            line-height: 1.4;
          }

          .stats-grid {
            grid-template-columns: 1fr !important;
            gap: 10px !important;
            margin: 16px 0 !important;
          }

          .stat-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            padding: 16px !important;
            border-radius: 12px !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
            background: white !important;
            margin-bottom: 8px !important;
          }

          .stat-content {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            width: 100% !important;
          }

          .stat-title {
            font-size: 12px !important;
            margin-bottom: 4px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.5px !important;
          }

          .stat-value {
            font-size: 28px !important;
            font-weight: 700 !important;
            line-height: 1 !important;
          }

          .stat-icon {
            opacity: 0.7 !important;
            width: 32px !important;
            height: 32px !important;
          }

          .upload-section {
            margin: 16px 0 !important;
          }

          .upload-zone {
            padding: 20px 16px !important;
            border-radius: 12px !important;
            background: #f8fafc !important;
            border: 2px dashed #cbd5e1 !important;
            text-align: center !important;
          }

          .upload-content h3 {
            font-size: 16px !important;
            margin-bottom: 8px !important;
            color: #1e293b !important;
          }

          .upload-content p {
            font-size: 13px !important;
            color: #64748b !important;
            margin-bottom: 16px !important;
          }

          .filters-section {
            padding: 16px !important;
            margin: 16px 0 !important;
            background: white !important;
            border-radius: 12px !important;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
            gap: 16px !important;
          }

          .search-box {
            max-width: none !important;
            width: 100% !important;
            margin-bottom: 16px !important;
          }

          .search-input {
            padding: 16px 20px 16px 48px !important;
            font-size: 16px !important;
            border-radius: 12px !important;
            border: 1px solid #e2e8f0 !important;
          }

          .filter-buttons {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 8px !important;
          }

          .filter-btn {
            padding: 16px !important;
            font-size: 15px !important;
            font-weight: 500 !important;
            border-radius: 10px !important;
            text-align: center !important;
            transition: all 0.2s !important;
          }

          .fichiers-container {
            margin: 16px 0 !important;
            border-radius: 12px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
          }

          .container-header {
            padding: 16px !important;
            background: #f8fafc !important;
            border-bottom: 1px solid #e2e8f0 !important;
          }

          .container-title {
            font-size: 16px !important;
            font-weight: 700 !important;
            color: #1e293b !important;
            margin: 0 !important;
            text-align: center !important;
          }

          .fichier-item {
            padding: 16px !important;
            margin: 0 !important;
            border-bottom: 1px solid #f1f5f9 !important;
            background: white !important;
          }

          .fichier-item:last-child {
            border-bottom: none !important;
          }

          .fichier-content {
            display: flex !important;
            flex-direction: column !important;
            gap: 12px !important;
          }

          .fichier-main {
            gap: 8px !important;
          }

          .fichier-title {
            font-size: 14px !important;
            font-weight: 600 !important;
            line-height: 1.3 !important;
            margin-bottom: 4px !important;
            color: #1e293b !important;
          }

          .fichier-description {
            font-size: 12px !important;
            line-height: 1.4 !important;
            color: #64748b !important;
            margin-bottom: 8px !important;
          }

          .fichier-meta {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 4px !important;
          }

          .meta-item {
            font-size: 10px !important;
            padding: 3px 6px !important;
            border-radius: 4px !important;
            background: #f1f5f9 !important;
            color: #475569 !important;
            display: flex !important;
            align-items: center !important;
            gap: 4px !important;
          }

          .action-buttons {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            width: 100% !important;
          }

          .btn-action {
            width: 100% !important;
            padding: 12px 8px !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            border-radius: 8px !important;
            justify-content: center !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            min-height: 44px !important;
          }

          .status-badge {
            font-size: 9px !important;
            padding: 3px 8px !important;
            border-radius: 12px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.3px !important;
          }
        }

        @media (min-width: 1024px) {
          .mobile-nav-header {
            display: none !important;
          }

          .main-wrapper {
            margin-left: 280px;
          }

          .main-content {
            max-width: calc(100vw - 280px);
            padding: 32px;
          }
        }

        @media (min-width: 1400px) {
          .main-content {
            max-width: 1200px;
            margin: 0 auto;
            padding: 40px;
          }

          .stats-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 24px;
          }

          .stat-card {
            padding: 32px;
          }

          .page-title {
            font-size: 42px;
          }

          .page-subtitle {
            font-size: 18px;
          }
        }

        @media (max-width: 1200px) {
          .main-content {
            padding: 20px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 1023px) {
          .main-wrapper {
            margin-left: 0;
          }

          .main-content {
            padding: 20px;
          }

          .page-title {
            font-size: 28px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }

          .stat-card {
            padding: 20px;
          }

          .filters-section {
            padding: 16px;
          }

          .filter-buttons {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }

          .filter-btn {
            padding: 12px 16px;
            font-size: 14px;
          }

          .fichier-item {
            padding: 20px;
          }

          .btn-action {
            padding: 12px 20px;
            font-size: 14px;
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 12px;
          }

          .header-content {
            flex-direction: column;
            align-items: center;
            gap: 16px;
            text-align: center;
          }

          .page-title {
            font-size: 24px;
            text-align: center;
            width: 100%;
          }

          .page-subtitle {
            text-align: center;
            width: 100%;
            font-size: 14px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }

          .stat-card {
            padding: 16px;
          }

          .stat-title {
            font-size: 14px;
          }

          .stat-value {
            font-size: 28px;
          }

          .upload-section {
            margin: 16px 0;
          }

          .upload-zone {
            padding: 24px 16px;
            text-align: center;
          }

          .upload-content h3 {
            font-size: 18px;
          }

          .upload-content p {
            font-size: 13px;
          }

          .filters-section {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 16px;
          }

          .search-box {
            max-width: none;
            width: 100%;
          }

          .search-input {
            padding: 14px 16px 14px 44px;
            font-size: 16px;
          }

          .filter-buttons {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .filter-btn {
            padding: 12px 16px;
            font-size: 13px;
            text-align: center;
          }

          .fichiers-container {
            margin: 16px 0;
          }

          .container-header {
            padding: 16px 20px;
          }

          .container-title {
            font-size: 18px;
          }

          .fichier-item {
            padding: 20px;
          }

          .fichier-content {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
          }

          .fichier-main {
            gap: 12px;
          }

          .fichier-title {
            font-size: 16px;
          }

          .fichier-description {
            font-size: 13px;
          }

          .fichier-meta {
            flex-wrap: wrap;
            gap: 8px;
          }

          .meta-item {
            font-size: 12px;
          }

          .fichier-actions {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
            justify-content: center;
          }

          .action-buttons {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            width: 100%;
          }

          .btn-action {
            flex: 1;
            min-width: 120px;
            justify-content: center;
            font-size: 13px;
            padding: 12px 16px;
          }

          .status-badge {
            font-size: 11px;
            padding: 6px 12px;
          }
        }

          .fichier-actions {
            flex-direction: column;
            gap: 12px;
          }

          .action-buttons {
            flex-direction: column;
          }

          .btn-action {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .main-wrapper {
            margin-left: 0;
            width: 100%;
          }

          .main-content {
            padding: 8px;
            margin-top: 70px; /* Espace pour la nav mobile fixe */
          }

          .header-content {
            padding: 20px 12px;
            text-align: center;
          }

          .page-title {
            font-size: 24px;
            margin-bottom: 8px;
            color: #1e293b;
            font-weight: 700;
          }

          .page-subtitle {
            font-size: 14px;
            color: #64748b;
            line-height: 1.5;
            margin-bottom: 20px;
          }

          .stats-grid {
            grid-template-columns: 1fr;
            gap: 12px;
            margin: 20px 0;
            padding: 0 8px;
          }

          .stat-card {
            padding: 20px;
            border-radius: 16px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            border: 1px solid #f1f5f9;
          }

          .stat-title {
            font-size: 16px;
            margin-bottom: 12px;
            font-weight: 600;
          }

          .stat-value {
            font-size: 32px;
            font-weight: 800;
          }

          .stat-icon {
            width: 40px;
            height: 40px;
          }

          .upload-section {
            margin: 24px 8px 20px 8px;
            padding: 0;
          }

          .upload-zone {
            padding: 24px 16px;
            border-radius: 12px;
            background: #f8fafc;
            border: 2px dashed #cbd5e1;
            text-align: center;
          }

          .upload-content h3 {
            font-size: 18px;
            margin-bottom: 8px;
            color: #1e293b;
          }

          .upload-content p {
            font-size: 14px;
            color: #64748b;
            margin-bottom: 16px;
          }

          .upload-zone {
            padding: 24px 16px;
            border-radius: 12px;
            background: #f8fafc;
            border: 2px dashed #cbd5e1;
            text-align: center;
          }

          .upload-content h3 {
            font-size: 18px;
            margin-bottom: 8px;
            color: #1e293b;
          }

          .upload-content p {
            font-size: 14px;
            color: #64748b;
            margin-bottom: 16px;
          }

          .filters-section {
            padding: 16px;
            margin: 20px 8px;
            background: white;
            border-radius: 12px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            gap: 16px;
          }

          .search-box {
            max-width: none;
            width: 100%;
            margin-bottom: 16px;
          }

          .search-input {
            padding: 16px 20px 16px 48px;
            font-size: 16px;
            border-radius: 12px;
            border: 1px solid #e2e8f0;
          }

          .filter-buttons {
            display: grid;
            grid-template-columns: 1fr;
            gap: 8px;
          }

          .filter-btn {
            padding: 16px;
            font-size: 15px;
            font-weight: 500;
            border-radius: 10px;
            text-align: center;
            transition: all 0.2s;
          }

          .fichiers-container {
            margin: 20px 8px;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .container-header {
            padding: 20px;
            background: #f8fafc;
            border-bottom: 1px solid #e2e8f0;
          }

          .container-title {
            font-size: 18px;
            font-weight: 700;
            color: #1e293b;
            margin: 0;
          }

          .fichier-item {
            padding: 20px;
            margin: 0;
            border-bottom: 1px solid #f1f5f9;
            background: white;
          }

          .fichier-item:last-child {
            border-bottom: none;
          }

          .fichier-content {
            gap: 16px;
          }

          .fichier-main {
            gap: 12px;
          }

          .fichier-title {
            font-size: 16px;
            font-weight: 600;
            color: #1e293b;
            line-height: 1.4;
            margin-bottom: 8px;
          }

          .fichier-description {
            font-size: 14px;
            line-height: 1.5;
            color: #64748b;
            margin-bottom: 12px;
          }

          .fichier-meta {
            gap: 8px;
            flex-direction: column;
            align-items: flex-start;
          }

          .meta-item {
            font-size: 12px;
            padding: 6px 12px;
            background: #f1f5f9;
            border-radius: 20px;
            color: #475569;
            font-weight: 500;
          }

          .action-buttons {
            flex-direction: column;
            gap: 8px;
          }

          .btn-action {
            min-width: auto;
            width: 100%;
            padding: 16px;
            font-size: 15px;
            font-weight: 600;
            border-radius: 10px;
            justify-content: center;
          }

          .btn-primary {
            background: #3b82f6;
            color: white;
            border: none;
          }

          .btn-secondary {
            background: #f1f5f9;
            color: #475569;
            border: 1px solid #e2e8f0;
          }

          .status-badge {
            font-size: 11px;
            padding: 6px 12px;
            border-radius: 20px;
            font-weight: 600;
            align-self: flex-start;
          }

          /* Mobile Navigation */
          .mobile-nav-header {
            display: flex !important;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1000;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          }

          .mobile-nav-title {
            font-size: 18px;
            font-weight: 700;
            color: white;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
          }

          .mobile-logout-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 16px;
            background: rgba(255, 255, 255, 0.2);
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            backdrop-filter: blur(10px);
          }

          .mobile-logout-btn:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateY(-1px);
          }

          .mobile-logout-btn:active {
            background: rgba(255, 255, 255, 0.1);
            transform: scale(0.98);
          }
        }

          .stat-card {
            padding: 12px;
          }

          .stat-title {
            font-size: 13px;
          }

          .stat-value {
            font-size: 24px;
          }

          .page-title {
            font-size: 20px;
          }

          .fichiers-container {
            border-radius: 12px;
          }

          .container-header {
            padding: 12px 16px;
          }

          .container-title {
            font-size: 16px;
          }

          .fichier-item {
            padding: 16px;
          }

          .fichier-title {
            font-size: 15px;
          }

          .fichier-meta {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
          }

          .meta-item {
            font-size: 11px;
          }

          .upload-zone {
            padding: 20px 12px;
          }

          .upload-content h3 {
            font-size: 16px;
          }

          .upload-content p {
            font-size: 12px;
          }

          .filters-section {
            padding: 12px;
          }

          .search-input {
            padding: 12px 16px 12px 40px;
            font-size: 16px;
          }

          .filter-buttons {
            grid-template-columns: 1fr;
          }

          .filter-btn {
            padding: 14px 16px;
          }

          .btn-action {
            min-width: 100px;
            font-size: 12px;
            padding: 10px 12px;
          }

          .status-badge {
            font-size: 10px;
            padding: 4px 8px;
          }

          .file-icon {
            font-size: 28px;
          }

          .notification {
            top: 80px;
            right: 8px;
            left: 8px;
            padding: 12px 16px;
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};
export default Echanges;
